var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9063 1.63901L16.4353 0.102005C16.4055 0.0699294 16.3692 0.0444617 16.3289 0.027239C16.2886 0.0100164 16.2452 0.00142076 16.2013 0.00200578C16.1574 0.000505203 16.1136 0.00868506 16.0732 0.0259659C16.0328 0.0432467 15.9966 0.0692054 15.9673 0.102005L5.76734 10.536L2.05634 6.76601C2.0264 6.73391 1.99017 6.70831 1.94992 6.69081C1.90966 6.67331 1.86623 6.66428 1.82234 6.66428C1.77844 6.66428 1.73502 6.67331 1.69476 6.69081C1.65451 6.70831 1.61828 6.73391 1.58834 6.76601L0.100339 8.27701C0.0685305 8.30877 0.0432963 8.34649 0.0260792 8.38802C0.00886207 8.42954 0 8.47405 0 8.51901C0 8.56396 0.00886207 8.60847 0.0260792 8.64999C0.0432963 8.69152 0.0685305 8.72924 0.100339 8.761L4.78134 13.515C5.03323 13.7958 5.38334 13.969 5.75934 13.999C6.12828 13.9649 6.47261 13.7992 6.72934 13.532H6.73734L17.9153 2.12301C17.9728 2.05498 18.0036 1.96836 18.002 1.87931C18.0003 1.79026 17.9663 1.70485 17.9063 1.63901Z",
    fill: "#031023"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.a51f54fb53e734a6ffa6f73617a6f768.svg";
export { ForwardRef as ReactComponent };